import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SingleClassAttendanceLayer from "../components/attendance/SingleClassAttendanceLayer";

const SingleClassAttendancePage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Class Attendance Details" />
      <SingleClassAttendanceLayer />
    </MasterLayout>
  );
};

export default SingleClassAttendancePage;
